const paymentHu = {
    "billing": {
        "name": "Név/Cégnév",
        "country": "Ország",
        "postal_code": "Irányítószám",
        "city": "Város",
        "address": "Cím",
        "tax_number": "Adószám",
        "phone": "Telefonszám",
        "tax_number_helper_text": "Cégek esetén kötelező, magánszemélyek esetén nem szükséges megadni",
        "billing_info": "Számlázási adatok",
        "emails_helper_text": "Opcionális. Több email cím esetén vesszővel elválasztva adja meg őket",
    },
    "subscription_plans": {
        "PRO": "Pro csomag",
        "FREE": "Ingyenes csomag",
    },

    "plan_descriptions": {
        "PRO": "Olyan vendéglátóhelyek számára, akik a következő szintre szeretnék emelni üzletüket! Fordítsd le étlapod pár kattintással új nyelvekre, kérj visszajelzést a vendégeidtől az ételekről, hasznos statisztikákon kövesd az QR kódos étlapod használatát vagy hagyd hogy a QuickPick AI automatikusan megválaszolja vendégeid visszajelzéseid a te stílusodban!",
        "FREE": "Olyan vendéglátóhelyek számára, akik szeretnék javítani online megjelenésüket. Hozd létre digitális étlapodat és engedd, hogy vendégeid könnyedén elérjék azt QR kódon keresztül!",
    },
    "subscription_status": {
        "ACTIVE": "Aktív",
        "CANCELLED": "Lemondva",
    },
    "next_billing_date": "Következő számlázás dátuma",
    "current_subscription": "Jelenlegi előfizetés",
    "cancel": "Lemondás",
    "subscription_interval_prices": {
        "MONTHLY": "hónap",
        "YEARLY": "év",
        "HALF_YEARLY": "félév",
        "QUARTERLY": "negyedév",
    },
    "subscription_interval_payment": {
        "MONTHLY": "Havi előfizetés",
        "YEARLY": "Éves előfizetés",
        "HALF_YEARLY": "Féléves előfizetés",
        "QUARTERLY": "Negyedéves előfizetés",
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Havi előfizetés",
        "YEARLY": "Éves előfizetés",
        "HALF_YEARLY": "Féléves előfizetés",
        "QUARTERLY": "Negyedéves előfizetés",
    },
    "reactivate": "Újraaktiválás",
    "valid_to": "Érvényes eddig",
    "payments_and_invoices": "Fizetések és számlák",
    "amount": "Összeg",
    "invoice": "Számla",
    "update_card": "Frissítés",
    "payment_method": "Fizetési mód",
    "cancel_subscription_confirmation": "Biztosan le szeretné mondani a jelenlegi előfizetést?",
    "cancel_subscription_valid_until": "Az előfizetés a következő időpontig érvényes marad",
    "subscription_cancelled": "Az előfizetés sikeresen lemondva",
    "reactivate_confirmation": "Biztosan újraaktiválja a lemondott előfizetést?",
    "reactivate_successful": "Az előfizetés sikeresen újraaktiválva",
    "change_payment_method": "Fizetési mód megváltoztatása",
    "change_payment_method_tooltip": "A fizetési adatok megváltoztatásához a következő előfizetői periódus fizetését kell teljesíteni. Természetesen az előfizetésedet a periódus hosszával meg fogjuk hosszabbítani és a következő számlázási időpont is ennyi idővel később lesz esedékes.",
    "amount_to_be_paid": "Fizetendő összeg",
    "new_subscription_valid_until": "Az új előfizetés érvényessége",
    "bank_card_expires_soon": "Az előfizetéshez használt bankkártya érvényessége hamarosan lejár.",
    "reactivate_subscription_confirmation": "Biztosan újraaktiválja a lemondott előfizetést?",
    "billing_information": "Számlázási adatok",
    "edit_billing_information": "Számlázási adatok szerkesztése",
    "no_available_invoices": "Nincs elérhető számla",
    "subscribe": "Előfizetek",
    "continue_to_payment": "Tovább a fizetéshez",
    "confirm_subscription": "Előfizetés megerősítése",
    "subscription_page_title": "Előfizetés megkezdése",
    "pay": "Fizetés",
    "available_plans": "Elérhető előfizetés",
    "accept_terms_and_conditions": "Elolvastam és elfogadom az <a>általános szerződési feltételekben</a> foglaltakat",
    "accept_recurring_payments": "A fizetéssel elfogadom az ismétlődő fizetések automatikus terhelését, amelyet bármikor lemondhatok.",
    "accept_privacy_policy": "Elolvastam és elfogadom az <a>adatvédelmi tájékoztatóban</a> foglaltakat",
    "subscribe_soon": "Hamarosan",
}

export default paymentHu;